import { getSvgIconName, SvgIcon } from '@bob/library'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapProductPage } from '@websrc/DataMappers/mapProductPage'
import clsx from 'clsx'
import { gridContainer, styles, typography } from 'leds'
import React from 'react'

export interface ProductInfoCalloutsProps {
  callouts: ReturnType<typeof mapProductPage>['product_details']['callouts']
  limit?: number
  hideTitle?: boolean
}

export const ProductInfoCallouts = ({ callouts, limit, hideTitle }: ProductInfoCalloutsProps) => {
  const t = useStaticText()

  const callOutsToShow = limit ? callouts.slice(0, limit) : callouts

  return callouts?.length > 0 ? (
    <>
      {!Boolean(hideTitle) ? (
        <div
          className={clsx(
            styles({ marginTop: 25, marginBottom: 16 }),
            typography({ color: 'grey', size: 'md' })
          )}
        >
          {t.ecom.callout_title}
        </div>
      ) : null}
      <div
        className={clsx(
          gridContainer(),
          styles({ marginBottom: 25, justifyContent: 'space-between', rowGap: 25 })
        )}
      >
        {callOutsToShow.map((callout, index) => (
          <div className={styles({ flexBasis: '48pct' })} key={index}>
            <div
              className={clsx(
                typography({ size: 'lg', weight: 'bold' }),
                styles({ display: 'flex', alignItems: 'center' })
              )}
            >
              {callout.heading.icon && (
                <SvgIcon
                  className={styles({ marginRight: 5 })}
                  name={getSvgIconName(callout.heading.icon)}
                  size={20}
                />
              )}
              {callout.heading.label}
            </div>
            <div>{callout.description}</div>
          </div>
        ))}
      </div>
    </>
  ) : null
}
